import {
  Alert,
  alpha,
  Badge,
  Box,
  Button,
  Chip,
  Container,
  Divider,
  Fab,
  FormControlLabel,
  Grid,
  InputBase,
  List,
  ListItem,
  OutlinedInput,
  Paper,
  Select,
  Stack,
  styled,
  Tab,
  Tabs,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import Link from "@mui/material/Link";
// import imgB from '../../public/static/Privacy/RectangleP.png'
//import { Link } from 'react-router-dom'

export const FlexContainerCol = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
});
export const FlexContainerSpaceBetween = styled(Box)({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});
export const FlexContainerCenter = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  maxWidth: "1400px",
  width: "100%",
  marginRight: "auto",
  marginLeft: "auto",
});
export const FlexContainer = styled(Box)({
  display: "flex",
  gap: ".5rem",
  overflowX: "auto",
  whiteSpace: "nowrap",
  flexWrap: "nowrap",
  padding: "8px 0px 8px 5px",
  typography: "body1",
  "& :not(style) + :not(style)": {
    ml: 1,
    // mr:2
  },
});
export const CustomTextField = styled(TextField)(({ theme }) => ({
  borderRadius: "13px",
  "& .MuiInputBase-input": {
    padding: "15px 10px",
    "& .MuiOutlinedInput-input": {
      padding: "4px 10px",
      borderRadius: "5px",
    },
  },
}));
export const CustomTextArea = styled(TextareaAutosize)(({ theme }) => ({
  padding: "10px",
  borderRadius: "8px",
  border: `1px solid ${theme.palette.primary.main}`,
  backgroundColor: theme.palette.neutral[100],
  color: theme.palette.neutral[1000],
}));
export const CustomPaper = styled(Paper)(({ theme, width, height }) => ({
  //backgroundColor: '#D1D5DB',
  padding: "2rem",
  maxWidth: width ? width : "600px",
  width: "100%",
  minHeight: "100px",
  height: height ? height : "100%",
  borderRadius: "20px",
  justifyContent: "center",
  textAlign: "center",
}));

export const CustomPaperBigCard = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'noboxshadow' && prop !== 'backgroundcolor' && prop !== 'nopadding' && prop !== 'minheight'
})(
  ({
    theme,
    nopadding,
    minheight,
    height,
    backgroundcolor,
    padding,
    width,
    noboxshadow,
  }) => ({
    backgroundColor: backgroundcolor
      ? backgroundcolor
      : theme.palette.background.paper,
    padding: nopadding === "true" ? "none" : padding ? padding : "1.875rem",
    width: width ? width : "100%",
    height: height ? height : "100%",
    minHeight: minheight && minheight,
    borderRadius: "10px",
    boxShadow:
      noboxshadow === "true"
        ? "none"
        : theme.palette.mode === "light"
          ? `0px 0px 2px rgba(145, 158, 171, 0.2), 0px 5px 20px ${theme.palette.paperBoxShadow}`
          : "none",
    // marginBottom: '30px',
  })
);

export const CustomButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {},
}));
export const CustomFullDivider = styled(Divider)(({ theme }) => ({
  width: "100%",
}));
export const LayoutCenter = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  height: "100%",
  paddingTop: "7.5rem",
}));
export const CustomAlert = styled(Alert)(({ theme }) => ({}));
export const OutletWrapper = styled(Container)(({ theme, iconicSidebar }) => ({
  display: "flex",
  flex: "1 1 auto",
  width: "100%",
  paddingTop: "6.25rem",
  paddingBottom: "10vh",
  [theme.breakpoints.up("lg")]: {
    paddingLeft: iconicSidebar ? 180 : 310,
  },
}));

export const CustomImageContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
  height: "100%",

  "& img": {
    width: "100%",
    height: "100%",
    borderRadius: "5px",
    objectFit: "contained",
  },
}));
export const CustomImageContainerWithBorderRadius = styled(Box)(
  ({ theme }) => ({
    borderRadius: "0.125rem",
    position: "relative",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "contained",
    },
  })
);
export const ImageContainer = styled(Box)(({ theme }) => ({
  borderRadius: "0.125rem",
  position: "relative",
  "& img": {
    width: "100%",
    height: "300px",
    objectFit: "contain",
  },
}));
export const CustomColouredTypography = styled(Typography)(
  ({ theme, color }) => ({
    color: color ? color : theme.palette.primary.main,
  })
);
export const CustomColouredTypographySubtitle = styled(Typography)(
  ({ theme }) => ({
    marginTop: "0.563rem",
    textTransform: "none",
    color: theme.palette.neutral[700],
  })
);

export const CenteringSingleComponentOnLayout = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
});

export const CustomStack = styled(Stack)({
  alignItems: "start",
  width: "100%",
  paddingLeft: "1rem",
});
export const CustomBoxTab = styled(Box)({
  border: "1px solid #0D9488",
  padding: "5px",
  borderRadius: "15px",
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    borderColor: "#0F766E",
    boxShadow: "0 4px 12px rgba(13, 148, 136, 0.2)",
    transform: "translateY(-2px)",
  },
});
export const CustomTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: "linear-gradient(135deg, #CCFBF1 0%, #99F6E4 100%)", // Teal light gradient
  borderRadius: "16px",
  padding: "6px",
  boxShadow: "0 4px 20px rgba(13, 148, 136, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
  border: "1px solid rgba(13, 148, 136, 0.1)",
  "& .MuiTabs-indicator": {
    backgroundColor: "linear-gradient(135deg, #0D9488 0%, #14B8A6 100%)", // Teal gradient
    borderRadius: "12px",
    height: "calc(100% - 4px)",
    top: "2px",
    zIndex: 0,
    boxShadow: "0 2px 8px rgba(13, 148, 136, 0.3)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  },
  "& .MuiTab-root": {
    borderRadius: "12px",
    margin: "0 3px",
    minHeight: "44px",
    zIndex: 1,
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    fontWeight: 500,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "rgba(13, 148, 136, 0.08)",
      transform: "translateY(-1px)",
    },
    "&.Mui-selected": {
      color: theme.palette.primary.contrastText,
      fontWeight: 600,
      textShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
    },
  },
  "& .MuiTabs-scrollButtons.Mui-disabled": {
    opacity: 0.3,
  },
}));
export const CloseIconWrapper = styled("div", {
  shouldForwardProp: (prop) => !["right"].includes(prop),
})(
  ({ theme, right }) => ({
    top: 0,
    right: right ? right : 0,
    height: "100%",
    position: "absolute",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  })
);

export const CustomFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  color: theme.palette.neutral[500],
}));

export const CustomBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    fontWeight: "bold",
  },
}));
export const CustomTypographyBold = styled(Typography)(
  ({ theme, marginTop }) => ({
    fontWeight: "bold",
  })
);
export const CustomTypographyAlign = styled(Typography)(({ theme, align }) => ({
  textAlign: align,
}));

export const CustomChip = styled(Chip)(({ theme }) => ({
  fontWeight: "bold",
}));

export const CustomIconButton = styled(Box)(({ theme, marginTop, align }) => ({
  display: "flex",
  justifyContent: align ? align : "center",
  alignItems: "center",
  color: theme.palette.neutral[700],
  cursor: "pointer",
  gap: "8px",
}));

export const CustomBoxFullWidth = styled(Box)(({ theme }) => ({
  width: "100%",
}));
export const CustomStackFullWidth = styled(Stack)(
  ({ theme, marginBottom, justifyContent }) => ({
    width: "100%",
    justifyContent: justifyContent,
  })
);
export const CustomBoxWithSpacing = styled(Box)(
  ({ theme, marginTopBottom }) => ({
    width: "100%",
    marginTop: marginTopBottom && `${marginTopBottom}rem`,
    marginBottom: marginTopBottom && `${marginTopBottom}rem`,
  })
);
// export const CustomLink = styled(Link)(({ theme, width }) => ({
//     textDecoration: 'none',
//     width: width ? '100%' : 'auto',
// }))
export const CustomSearch = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.mode === 'dark' 
    ? theme.palette.background.paper 
    : theme.palette.neutral[100],
  color: theme.palette.text.primary,
  //alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    //backgroundColor: alpha(theme.palette.common.white, 0.25),
    backgroundColor: theme.palette.mode === 'dark' 
      ? alpha(theme.palette.background.paper, 0.9)
      : theme.palette.neutral[100],
  },
  marginLeft: 0,
  marginRight: "10px",
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));
export const SearchIconWrapper = styled("div")(
  ({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  })
);
export const StyledInputBase = styled(InputBase)(({ theme, width }) => ({
  color: "inherit",
  width: "120px",
  border: "2px solid #EF7822",
  padding: "5px 0",
  marginLeft: "5px",
  borderRadius: "5px",
  "& .MuiInputBase-input": {
    fontSize: "1.3rem",
    textAlign: "center",
  },
}));
export const SearchInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "40ch",
      "&:focus": {
        width: "50ch",
      },
    },
  },
}));
export const Logo = styled("div")(({ theme, height, width }) => ({
  width: width,
  height: height,
  justifyContent: "center",

  position: "relative",
  cursor: "pointer",
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "contained",
  },
}));
export const CustomBoxNav = styled(Box)(({ theme, isSmall }) => ({
  // display: isSmall ? 'none' : 'inline',
  flexGrow: 1,
}));
export const CustomLink = styled(Link)(({ theme, color }) => ({
  color: color ? color : "primary.main",
  cursor: "pointer",
  fontWeight: "700",
  textDecoration: "none",
  "&:hover": {
    //backgroundColor: alpha(theme.palette.common.white, 0.25),
    color: theme.palette.primary.dark,
    textDecoration: "none",
  },
  "&:focus": {
    textDecoration: "none",
  },
  "&:active": {
    textDecoration: "none",
  },
}));
export const CustomOtp = styled(OutlinedInput)(({ theme }) => ({
  width: "60px",
}));
export const CustomTextFieldContainer = styled(Box)(
  ({ theme, background, noheight }) => ({
    width: "100%",
    height: !noheight && "5.5rem",
    color: theme.palette.neutral[1000],
  })
);
export const CustomStackForLoaction = styled(Stack)(({ theme }) => ({
  justifyContent: "center",
  cursor: "pointer",
  alignItems: "center",
}));
export const CustomOverlayBox = styled(Box)(({ theme, height, top }) => ({
  position: "absolute",
  bottom: 0,
  left: 0,
  top: top ? top : 0,
  width: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.54)",
  color: theme.palette.whiteContainer.main,
  // padding: '10px',
  height: height ? height : "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: "999",
}));
export const EmptyMessageContainer = styled(CustomStackFullWidth)(
  ({ theme }) => ({
    height: "20vh",
    width: "25vw",
  })
);
export const CustomViewAll = styled(Stack)(({ theme }) => ({
  justifyContent: "end",
  color: theme.palette.primary.main,
  paddingTop: "5px",
  paddingBottom: "5px",
  fontSize: "14px",
  cursor: "pointer",
}));
export const CustomFab = styled(Fab)(({ theme, module_type }) => ({
  width: "30px",
  height: "30px",
  minHeight: "30px",

  [theme.breakpoints.down("sm")]: {
    width: "30px",
    height: "30px",
  },
}));
export const CustomImageContainerStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'objectfit' && prop !== 'sm_width' && prop !== 'max_width' && prop !== 'margin_bottom' && prop !== 'smheight' && prop !== 'minwidth' && prop !== 'border_radius' && prop !== 'sm_mb' && prop !== 'sm_max_width' && prop !== 'mdHeight' && prop !== 'aspect_ratio'
})(
  ({
    theme,
    sm_width,
    max_width,
    margin_bottom,
    width,
    smheight,
    height,
    objectfit,
    minwidth,
    border_radius,
    sm_mb,
    sm_max_width,
    mdHeight,
    cursor,
    aspect_ratio,
    padding,
  }) => ({
    display: "inline-flex",
    background: "transparent",
    width: width ? width : "100%",
    height: height ? height : "100%",
    minWidth: minwidth,
    maxWidth: max_width,
    padding: padding ? padding : "",
    marginBottom: margin_bottom,
    position: "relative",
    borderRadius: border_radius ? border_radius : "12px",
    overflow: "hidden",
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: objectfit ? objectfit : "cover",
      borderRadius: border_radius ? border_radius : "12px",
      aspectRatio: aspect_ratio ? aspect_ratio : "",
      transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    },
    "&:hover": {
      transform: "translateY(-4px) scale(1.02)",
      boxShadow: "0 12px 40px rgba(13, 148, 136, 0.2), 0 4px 12px rgba(0, 0, 0, 0.1)",
      "& img": {
        transform: "scale(1.05)",
      },
    },
    [theme.breakpoints.down("md")]: {
      height: mdHeight ? mdHeight : "",
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: sm_mb ? sm_mb : "",
      height: smheight ? smheight : "",
      maxWidth: sm_max_width ? sm_max_width : "",
      width: sm_width ? sm_width : "",
    },
  })
);
export const CustomListItem = styled(ListItem)(
  ({ theme, display, cursor, border }) => ({
    display: display,
    cursor: cursor && "pointer",
    border: border,
    borderRadius: "10px",

    paddingInline: "5px",
    justifyContent: "flex-start",
    // "&:hover": {
    //   boxShadow: `0px 4px 4px 0px ${alpha(theme.palette.neutral[1000], 0.05)}`,
    //   border: `1px solid ${alpha(theme.palette.neutral[400], 0.5)}`,
    // },
  })
);
export const CustomBoxRelative = styled(Box)(({ theme, maxWidth, height }) => ({
  position: "relative",
  textAlign: "center",
  maxWidth: maxWidth,
  width: "100%",
  height: height,
}));
export const CustomBoxAbsoluteCenter = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
}));
export const ccsSelect = styled(Select)(({ theme }) => ({
  select: {
    "&:before": {
      borderColor: (theme) => theme.palette.primary.main,
    },
    "&:after": {
      borderColor: (theme) => theme.palette.primary.main,
    },
  },
  icon: {
    fill: (theme) => theme.palette.primary.main,
  },
}));

export const BackImage = styled(Stack)(({ theme }) => ({
  backgroundImage:
    "url('https://media.geeksforgeeks.org/wp-content/uploads/rk.png')",
}));
export const CustomList = styled(List)(({ theme, border }) => ({
  paddingTop: "0px",
}));
export const SliderCustom = styled(Stack)(
  ({ theme, language_direction, nopadding, paddingBottom }) => ({
    position: "relative",
    width: "100%",
    paddingY: "10px",
    backgroundColor: "transparent",
    "& .slick-slider": {
      backgroundColor: "transparent",
      "& .slick-slide": {
        padding: "6px",
        "& > div": {
          backgroundColor: "transparent",
        },
      },
      "& .slick-list": {
        backgroundColor: "transparent",
        paddingY: nopadding !== "true" && "8px",
        //paddingBottom: "1rem !important",
        "& .slick-track": {
          backgroundColor: "transparent",
          float: theme.direction === "ltr" ? "left" : "right",
          gap: "5px",
          //paddingBottom: paddingBottom && "1rem !important",
        },
      },
      "& .slick-arrow": {
        backgroundColor: theme.palette.mode === 'dark' 
          ? alpha(theme.palette.background.paper, 0.8)
          : alpha(theme.palette.common.white, 0.9),
        "&:before": {
          color: theme.palette.mode === 'dark' 
            ? theme.palette.text.primary
            : theme.palette.text.primary,
        },
        "&:hover": {
          backgroundColor: theme.palette.mode === 'dark' 
            ? alpha(theme.palette.background.paper, 0.95)
            : theme.palette.common.white,
        },
      },
    },
  })
);

export const CustomHeroBackground = styled(Box)(({ theme, bgImg }) => ({
  backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.15),
  width: "100%",
  height: "100%",
  paddingTop: "8.25rem",
  backgroundImage: `url(${bgImg})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
}));
export const customScrollBar = styled(Stack)(({ theme, height }) => ({
  overflowY: "auto",
  height: height,
  "&:hover::-webkit-scrollbar": {
    display: "block",
  },
  "&::-webkit-scrollbar": {
    display: "none",
    width: "0.512rem",
  },
  "&::-webkit-scrollbar-track": {
    boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#8d8e90",
    height: "8px",
    borderRadius: "8px",
  },
}));
export const CustomTypographyGray = styled(Typography)(
  ({ theme, nodefaultfont, textdecoration }) => ({
    color: theme.palette.text.secondary,
    fontWeight: "bold",
    fontSize: nodefaultfont !== "true" && "1rem",
    textDecoration: textdecoration,
  })
);
export const CustomBoxForTips = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active'
})(({ theme, active }) => ({
  paddingInline: "10px",
  height: "50px",
  width: "auto",
  minWidth: "50px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid ",
  borderColor: theme.palette.primary.main,
  cursor: "pointer",
  borderRadius: "5px",
  background: active && theme.palette.primary.main,
  position: "relative",
  [theme.breakpoints.down("sm")]: {
    height: "30px",
    paddingInline: "5px",
  },
}));
export const CustomZoom = styled(Stack)(({ theme }) => ({}));
export const StoreDetailsNavButton = styled(Button)(
  ({
    theme,
    color,
    background,
    language_direction,
    borderRigthTop,
    borderRightBottom,
    borderLeftBottom,
    borderLeftTop,
  }) => ({
    backgroundColor: background ? theme.palette.primary.main : "inherit",
    color: background
      ? theme.palette.whiteContainer.main
      : theme.palette.neutral[1000],
    borderRadius: "15px",
    borderBottomLeftRadius: borderLeftBottom && borderLeftBottom,

    "&:hover": {
      backgroundColor: background && theme.palette.primary.deep,
    },
  })
);
export const CustomModalWrapper = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "8px",
  backgroundColor: theme.palette.background.paper,
  padding: "16px",
  outline: "none",
  maxHeight: "90vh",
  overflow: "auto",
  pointerEvents: "auto",
}));
// export const phoneWrapper=styled((Stack)(({theme})=>({
//
// }))
export const PhoneWrapper = styled(Stack)(({ theme, lanDirection }) => ({
  "&.react-tel-input .special-label": {
    color: theme.palette.neutral[1000],
    left: "10px",
    background: theme.palette.neutral[100],
  },
  "&.react-tel-input .form-control": {
    background: theme.palette.neutral[100],
    color: theme.palette.neutral[1000],
    padding: "1px 70px 0px 1px",
    borderRadius: "8px",
  },
  "&.react-tel-input .form-control:focus": {
    borderColor: theme.palette.primary.main,
    borderWidth: "2px",
    zIndex: 999,
    boxShadow: "none",
  },
  "&.react-tel-input .country-list .country-name": {
    color: "#000000",
  },
  "&.react-tel-input .flag-dropdown": {
    borderRadius: "8px 0px 0px 8px",
  },
  "&.react-tel-input .selected-flag": {
    marginRight: lanDirection === "rtl" ? "30px" : "0px",
    padding: " 0 0px 0 11px",
  },
  "&.react-tel-input .selected-flag .arrow": {
    left: "29px",
  },
}));
export const StoreImageBox = styled(Box)(
  ({ theme, borderraduis, padding, border }) => ({
    padding: padding ? padding : "12px",
    border: border,
    borderRadius: borderraduis ? borderraduis : "5px",
    display: "flex",
    alignItems: "center",
    position: "relative",
    width: "76px",
    [theme.breakpoints.down("md")]: {
      padding: "18px",
      width: "81px",
    },
  })
);

export const AddressTypeStack = styled(Stack)(
  ({ theme, addressType, value }) => ({
    padding: "10px",
    border:
      value === addressType
        ? `1px solid ${theme.palette.primary.main}`
        : `1px solid ${alpha(theme.palette.neutral[400], 0.5)}`,
    borderRadius: "5px",
    background: value === addressType && alpha(theme.palette.primary.main, 0.2),
    cursor: "pointer",
  })
);
export const ScheduleTimeStack = styled(Stack)(({ theme }) => ({
  padding: "14px",
  background: alpha(theme.palette.neutral[400], 0.3),
  maxWidth: "244px",
  width: "100%",
  border: `1px solid ${theme.palette.neutral[300]}`,
  borderRadius: "5px",
  justifyContent: "center",
  alignItems: "center",
}));
export const UserInfoGrid = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'userToken' && prop !== 'page'
})(({ theme, page, userToken }) => ({
  position: "relative",
  zIndex: 99,
  minHeight: "100px",
  "&::before": {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: userToken ? "42%" : "0%",
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    zIndex: -1,
    [theme.breakpoints.down("md")]: {
      bottom:
        page === "profile-settings" ? "81%" : page === "inbox" ? "0%" : "37%",
    },
  },

  "&::after": {
    content: '""',
    position: "absolute",
    left: 0,
    bottom: userToken ? "42%" : "0%",
    top: 0,
    right: 0,
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    zIndex: -1,
    [theme.breakpoints.down("md")]: {
      bottom:
        page === "profile-settings" ? "81%" : page === "inbox" ? "0%" : "37%",
    },
  },
}));
export const UserProfileTabs = styled(Box, {
  shouldForwardProp: (prop) => !['value', 'variant', 'scrollButtons', 'TabIndicatorProps'].includes(prop),
})(({ theme, isActive }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  overflowX: 'auto',
  gap: '8px',
  // borderBottom: `1px solid ${alpha(theme.palette.neutral[400], 0.5)}`,
  // paddingBottom: "20px",
}));

export const UserProfileTab = styled(Button, {
  shouldForwardProp: (prop) => !['page', 'item', 'marginright', 'fontSize', 'borderRadius'].includes(prop),
})(
  ({ theme, page, item, marginright, fontSize, borderRadius }) => ({
    background: item?.name === page ?
      "linear-gradient(135deg, rgba(46, 134, 171, 0.15) 0%, rgba(58, 155, 193, 0.1) 100%)" :
      "transparent",
    paddingInlineEnd: "15px",
    paddingInlineStart: "15px",
    marginInlineEnd: marginright ? marginright : "25px",
    paddingBlockEnd: "0px",
    paddingBlockStart: "0px",
    borderRadius: borderRadius ? borderRadius : "12px",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    border: item?.name === page ? "1px solid rgba(46, 134, 171, 0.2)" : "1px solid transparent",
    boxShadow: item?.name === page ? "0 2px 8px rgba(46, 134, 171, 0.1)" : "none",
    "&:hover": {
      backgroundColor: "linear-gradient(135deg, rgba(46, 134, 171, 0.12) 0%, rgba(58, 155, 193, 0.08) 100%)",
      transform: "translateY(-2px) scale(1.02)",
      boxShadow: "0 4px 16px rgba(46, 134, 171, 0.15)",
      borderColor: "rgba(46, 134, 171, 0.3)",
    },
    [theme.breakpoints.down("sm")]: {
      marginInlineEnd: "10px",
      paddingInlineEnd: "7px",
      paddingInlineStart: "7px",
    },
  })
);

export const RoundedStack = styled(Stack)(
  ({ theme, width, height, background, smwidth, smheight }) => ({
    width: width,
    height: height,
    backgroundColor: background,
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    [theme.breakpoints.down("md")]: {
      width: smwidth,
      height: smheight,
    },
  })
);
export const CouponStyle = styled(Stack)(({ theme }) => ({
  position: "relative",
  "&::after": {
    position: " absolute",
    content: '""',
    display: "block",
    width: "22px",
    height: "22px",
    backgroundColor: "#D9D9D9",
    top: "-20px",
    right: "-9px",
    zIndex: 1,
    borderRadius: "50%",
  },
  "&::before": {
    position: " absolute",
    content: '""',
    display: "block",
    width: "22px",
    height: "22px",
    backgroundColor: "#D9D9D9",
    bottom: "-20px",
    right: "-10px",
    zIndex: 1,
    borderRadius: "50%",
  },
}));
export const PageDetailsWrapper = styled(CustomStackFullWidth)(({ theme }) => ({
  marginTop: "1rem",
}));
export const CustomStackForFoodModal = styled(Stack)(({ theme, padding }) => ({
  padding: padding ? padding : "18px",
  position: "absolute",
  bottom: "0",
  background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgb(18 18 18 / 94%) 100%)`,
}));
export const CustomSpan = styled("span")(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

// Enhanced Metallic Blue Components
export const MetallicButton = styled(Button)(({ theme, variant = "primary" }) => ({
  background: variant === "primary" ?
    "linear-gradient(135deg, #2E86AB 0%, #3A9BC1 50%, #4BA3C7 100%)" :
    "linear-gradient(135deg, #E8F4F8 0%, #D1E7ED 100%)",
  color: variant === "primary" ? "#FFFFFF" : "#2E86AB",
  border: "none",
  borderRadius: "12px",
  padding: "12px 24px",
  fontWeight: 600,
  textTransform: "none",
  boxShadow: variant === "primary" ?
    "0 4px 15px rgba(46, 134, 171, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2)" :
    "0 2px 8px rgba(46, 134, 171, 0.1)",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  position: "relative",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: "-100%",
    width: "100%",
    height: "100%",
    background: "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)",
    transition: "left 0.5s ease-in-out",
  },
  "&:hover": {
    transform: "translateY(-2px) scale(1.02)",
    boxShadow: variant === "primary" ?
      "0 8px 25px rgba(46, 134, 171, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.3)" :
      "0 6px 20px rgba(46, 134, 171, 0.2)",
    "&::before": {
      left: "100%",
    },
  },
  "&:active": {
    transform: "translateY(0) scale(0.98)",
  },
}));

export const MetallicCard = styled(Paper)(({ theme }) => ({
  background: theme.palette.mode === 'dark'
    ? `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${alpha(theme.palette.background.paper, 0.95)} 100%)`
    : "linear-gradient(135deg, #FFFFFF 0%, #F8FCFD 100%)",
  borderRadius: "16px",
  padding: "24px",
  border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
  boxShadow: theme.palette.mode === 'dark'
    ? `0 8px 32px ${alpha(theme.palette.common.black, 0.3)}, inset 0 1px 0 ${alpha(theme.palette.common.white, 0.05)}`
    : "0 8px 32px rgba(46, 134, 171, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
  position: "relative",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "2px",
    background: "linear-gradient(90deg, #2E86AB, #3A9BC1, #5DADE2)",
    opacity: 0,
    transition: "opacity 0.3s ease-in-out",
  },
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: theme.palette.mode === 'dark'
      ? `0 16px 48px ${alpha(theme.palette.common.black, 0.4)}, inset 0 1px 0 ${alpha(theme.palette.common.white, 0.08)}`
      : "0 16px 48px rgba(46, 134, 171, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.9)",
    "&::before": {
      opacity: 1,
    },
  },
}));

export const AnimatedBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    background: "linear-gradient(135deg, #2E86AB 0%, #3A9BC1 100%)",
    color: "#FFFFFF",
    fontWeight: 600,
    fontSize: "0.75rem",
    minWidth: "20px",
    height: "20px",
    borderRadius: "10px",
    border: "2px solid #FFFFFF",
    boxShadow: "0 2px 8px rgba(46, 134, 171, 0.3)",
    animation: "pulse 2s infinite",
  },
  "@keyframes pulse": {
    "0%": {
      transform: "scale(1)",
      boxShadow: "0 2px 8px rgba(46, 134, 171, 0.3)",
    },
    "50%": {
      transform: "scale(1.1)",
      boxShadow: "0 4px 16px rgba(46, 134, 171, 0.5)",
    },
    "100%": {
      transform: "scale(1)",
      boxShadow: "0 2px 8px rgba(46, 134, 171, 0.3)",
    },
  },
}));
